import { useTranslation } from 'next-i18next'

import DropdownMenu from '~/components/DropdownMenu/DropdownMenu'
import MultiSelect from '~/components/MultiSelect'
import useSettingsFormContext from '~/hooks/useSettingsFormContext'
import { FieldError } from '~/components/FieldError'
import { PreferredDay } from '~/types/booking'
import { UserRole } from '~/types/user-info-types'

export default function PreferredDays({ role }: { role: UserRole }): React.ReactElement {
  const namespace = role === UserRole.TUTOR ? 'tutorPanel' : 'studentPanel'
  const { t } = useTranslation(['booking', namespace])
  const { fields, errors, setFields } = useSettingsFormContext()

  const dropdownMenuHeader = t(`${namespace}:settings.labelPreferredDays` as const)
  const selectedStateLabel = fields.timeslots.map((elem) => t(`booking:preferredDays.${elem.day}` as const)).join(', ')

  const handleOnClick = (item: PreferredDay): void => {
    setFields((prevState) => {
      const prevItems = prevState.timeslots

      return {
        ...prevState,
        timeslots: !prevItems.some((elem) => elem.day === item)
          ? [...prevItems, { day: item, startHour: 8, endHour: 23 }]
          : prevItems.filter((elem) => elem.day !== item),
      }
    })
  }

  const items = Object.values(PreferredDay).map((elem) => ({
    value: elem,
    label: t(`booking:preferredDays.${elem}`),
  }))

  return (
    <div>
      <DropdownMenu header={dropdownMenuHeader} selectedStateLabel={selectedStateLabel}>
        <MultiSelect handleOnClick={handleOnClick} items={items} state={fields.timeslots.map((elem) => elem.day)} />
      </DropdownMenu>
      <FieldError error={errors.timeslots} />
    </div>
  )
}
